import React from "react";
import Login from "../login/login";
import landingPageImageOne from "../../assets/image/landingPageImageOne.svg";
import landingPageImageTwo from "../../assets/image/landingPageImageTwo.svg";
import logo from "../../assets/images/LucyLogo.png";
import "./landing-page.scss";

function LandingPage() {
  return (
    <div className="landing-page">
      <div className="landing-page-wrapper">
        <div className="landing-page-wrapper-right">
          <div className="landing-page-wrapper-right-content">
            <div className="landing-page-wrapper-right-content-overlay"></div>
            <div className="landing-page-wrapper-right-content-logo-container">
              <div className="landing-page-wrapper-right-content-logo-top-img">
                <img src={landingPageImageTwo} alt="Landing Page Logo" />
              </div>
              <div className="landing-page-wrapper-right-content-logo">
                <img
                  src={logo}
                  alt="Logo"
                  className="dashboard-header-content-logo-img"
                />
              </div>
              <p className="landing-page-wrapper-right-content-subtext">
                Your one-stop hub for tracking goals, driving progress, and
                leading with clarity. Let’s achieve more, together.
              </p>
              <img
                src={landingPageImageOne}
                alt="Running Girl"
                className="landing-page-wrapper-right-content-illustration"
              />
            </div>
          </div>
        </div>
        <div className="landing-page-wrapper-left">
          <Login />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
